var OVERLAY_SIZE_TYPE = {
  PIXEL: 'PIXEL',
  PERCENT: 'PERCENT'
};
export default OVERLAY_SIZE_TYPE;